import { Injectable } from '@angular/core';
import axios from 'axios'
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment"
@Injectable({
  providedIn: 'root'
})
export class VimeoService {

  constructor() { }
  async vimeoData(videoId): Promise<Observable<any>> {
    const config = {
      headers: {
        'Authorization': environment.VIMEO_TOKEN,
      }
    };
    return await axios.get(`https://api.vimeo.com/videos/${videoId}/pictures`, config)
  }
  async vimeoFullData(videoId): Promise<Observable<any>> {
    const config = {
      headers: {
        'Authorization': environment.VIMEO_TOKEN,
      }
    };
    return await axios.get(`https://api.vimeo.com/videos/${videoId}`, config)
  }
}
